// extracted by mini-css-extract-plugin
export default {"secondary-column-cell":"secondary-column-cell_j4klE","secondaryColumnCell":"secondary-column-cell_j4klE","tooltip":"tooltip_f1992"};